// apps/web/src/app/serahan.ts
/**
 * What one page may hand to the next for the shell to read out (PindahHalaman): a key of this
 * fixed list of sentences, never a sentence of the caller's making, so nothing typed (an
 * e-mail, a name, a NIK) is ever read out. The page's own sentence on screen may say more
 * (Tambah orang's names the account's e-mail); the shell reads only the fixed words.
 * DOM-free and relative-free: the wizards' node tests import it.
 */
import { uiStrings } from '@satu/shared'

const w = uiStrings.pelayan.wizard

export const UMUMKAN = {
  /** Tambah orang: saved. */
  orangTersimpan: w.tersimpan,
  /** Tambah orang: saved, and the account made. */
  orangAkunDibuat: w.umumkanAkunDibuat,
  /** Tambah orang: saved, the account not made (the page says why). */
  orangAkunGagal: w.umumkanAkunGagal,
  /** Tambah orang: kept on this device, the server refused the assignment. */
  orangTugasDitolak: w.tugasDitolakAkun,
} as const

export type KunciUmumkan = keyof typeof UMUMKAN

/** The router state a navigation hands to the next page. */
export interface SerahanHalaman {
  umumkan?: KunciUmumkan
}

/** The sentence for a key of the list; anything else (a sentence, a stray key) is nothing. */
export function kalimatUmumkan(kunci: unknown): string | null {
  if (typeof kunci !== 'string' || !Object.hasOwn(UMUMKAN, kunci)) return null
  return UMUMKAN[kunci as KunciUmumkan]
}
